import {
  byId,
  byClass,
  setStyle,
  getViewPortHeight,
  calcPositionDiff,
  getCurrentPage,
  getQueryString,
  getBrowser,
  isMobile,
  show
} from './utils'
import {
  setPageDownBlack,
  setPageDownWhite
} from './pagedown'

// 获取年数
let yearCount = parseInt(getQueryString('year') || 40)
// 一个数字的高度
const yearHeight = isMobile() ? 28 : 13.9

function generateYearNumber () {
  if (yearCount < 1) return
  const availableYears = [1, 3, 5, 7, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55]
  let availableYear = availableYears.findIndex(year => year > yearCount)
  if (availableYear === -1) availableYear = availableYears.length
  // 动画垂直移动距离
  const animationTop = (1 - availableYear) * yearHeight
  cloneYearNumber()
  updateKeyFrame(animationTop)
}

let keyFrameStyleEl
function updateKeyFrame (animationTop) {
  if (!document.body.classList.contains('ready')) {
    // 页面加载中，延迟开始动画
    setTimeout(() => updateKeyFrame(animationTop), 50)
    return
  }
  show(yearNumberCopyEl)
  // js创建 @keyframes
  const keyframes =`@keyframes celebrating-years-roll {
    0% { top: ${yearHeight}vw; }
    100% { top: ${animationTop}vw; }
  }`
  if (keyFrameStyleEl) {
    keyFrameStyleEl.innerHTML = keyframes
  } else {
    // 创建 style 标签
    keyFrameStyleEl = document.createElement('style')
    keyFrameStyleEl.type = 'text/css'
    // 将 keyframes 样式写入 style 内
    keyFrameStyleEl.innerHTML = keyframes
    // 将 style 样式存放到 head 标签
    document.getElementsByTagName('head')[0].appendChild(keyFrameStyleEl)
  }
  yearNumberEl.classList.add('ready')
  yearNumberCopyEl.classList.add('ready')
}

let yearNumberEl = byClass('years-container')
let yearNumberCopyEl
let yearNumberSource
let yearNumberTarget
function cloneYearNumber () {
  if (!yearNumberCopyEl) {
    yearNumberCopyEl = yearNumberEl.cloneNode(true)
    yearNumberCopyEl.classList.add('years-container-copy')
    byClass('celebrating').appendChild(yearNumberCopyEl)
    calcYearNumberPosition()
    setStyle(yearNumberCopyEl, {
      top: `${yearNumberSource.y}px`,
      left: `${yearNumberSource.x}px`,
      transform: 'scale(1)'
    })
  }
}

/**
 * Year Number 滚动联动（Hero）效果实现
 */
function animateCelebrating () {
  if (yearCount < 1 ||
      isMobile() ||
      getBrowser() === 'ie' ||
      getCurrentPage() !== 'celebrating' &&
      getCurrentPage() !== 'yearbook') {
    return
  }
  calcYearNumberPosition()
  // 计算两个页面之间停留的位置百分比
  const pageEl = byId('celebrating').parentElement
  const currentTopPos = -pageEl.getBoundingClientRect().top
  const scrollHeight = pageEl.scrollHeight - getViewPortHeight()
  let percent = currentTopPos / scrollHeight
  if (percent < 0) percent = 0
  else if (percent > 1) percent = 1
  animateYearNumber(percent)
  animateYearbook(percent)
  togglePageDownColor(percent)
}

/**
 * 通过百分比得到 Year Number 联动中间点坐标
 */
function animateYearNumber (percent) {
  percent = percent * 1.8 > 1 ? 1 : percent * 1.8
  const top = (yearNumberTarget.y - yearNumberSource.y) * percent + yearNumberSource.y
  const left = (yearNumberTarget.x - yearNumberSource.x) * percent + yearNumberSource.x
  const scale = (yearNumberTarget.scale - 1) * percent + 1
  setStyle(yearNumberCopyEl, {
    top: `${top.toFixed(2)}px`,
    left: `${left.toFixed(2)}px`,
    transform: `scale(${scale.toFixed(2)})`,
    visibility: 'visible'
  })
}

function animateYearbook (percent) {
  const yearbookEl = byId('yearbook')
  if (!yearbookEl) return
  if (getBrowser() === 'edge') {
    // Edge 不支持 clip-path，用 clip 代替
    if (percent > 0.9) percent = 1
    const width = yearbookEl.clientWidth
    const height = yearbookEl.clientHeight
    const x = width * (1 - percent)
    const y = height * percent
    setStyle(yearbookEl, {
      'clip': `rect(0px, ${width}px, ${y}px, ${x}px)`
    })
  } else {
    const circleSize = (percent).toFixed(3) * 180
    setStyle(yearbookEl, {
      '-webkit-clip-path': `circle(${circleSize}% at 80% 35%)`,
      'clip-path': `circle(${circleSize}% at 80% 35%)`
    })
  }
}

function togglePageDownColor (percent) {
  if (percent < 0.5) {
    setPageDownWhite()
  } else {
    setPageDownBlack()
  }
}

function calcYearNumberPosition () {
  if (yearCount < 1) return
  const sourcePos = calcPositionDiff(byId('celebrating'), byClass('years-container'))
  const anchorPos = calcPositionDiff(byId('yearbook'), byClass('years-number-anchor'))
  yearNumberSource = {
    x: sourcePos.x,
    y: sourcePos.y
  }
  yearNumberTarget = anchorPos ? {
    x: anchorPos.x,
    y: anchorPos.y,
    scale: 0.8
  } : yearNumberSource
}

export {
  generateYearNumber,
  animateCelebrating,
  calcYearNumberPosition
}
